import { computed, ComputedRef, Ref } from 'vue'

// This is because of an ESlint bug: https://github.com/typescript-eslint/tslint-to-eslint-config/issues/856
// eslint-disable-next-line 
export const enum PasswordValidationStatus {
  None = 'none',
  Valid = 'valid',
  Invalid = 'invalid',
}

type PasswordValidationModel = {
  text: string,
  status: PasswordValidationStatus
  dataTest: string
}

export interface PasswordValidationUseCase {
  validators: ComputedRef<PasswordValidationModel[]>
}

const lengthValidation = (password: string): PasswordValidationModel => {
  let status = PasswordValidationStatus.None
  if (password !== '') {
    status = password.length >= 6 ? PasswordValidationStatus.Valid : PasswordValidationStatus.Invalid
  }
  return {
    text: 'common.messages.password_update_validation_length',
    status,
    dataTest: 'password-length-validation',
  }
}

const lowercaseValidation = (password: string): PasswordValidationModel => {
  let status = PasswordValidationStatus.None
  if (password !== '') {
    status = password.match(/[a-z]/g) ? PasswordValidationStatus.Valid : PasswordValidationStatus.Invalid
  }
  return {
    text: 'common.messages.password_update_validation_lowercase',
    status,
    dataTest: 'password-lowercase-validation',
  }
}

const uppercaseValidation = (password: string): PasswordValidationModel => {
  let status = PasswordValidationStatus.None
  if (password !== '') {
    status = password.match(/[A-Z]/g) ? PasswordValidationStatus.Valid : PasswordValidationStatus.Invalid
  }
  return {
    text: 'common.messages.password_update_validation_uppercase',
    status,
    dataTest: 'password-uppercase-validation',
  }
}

const digitValidation = (password: string): PasswordValidationModel => {
  let status = PasswordValidationStatus.None
  if (password !== '') {
    status = password.match(/\d/g) ? PasswordValidationStatus.Valid : PasswordValidationStatus.Invalid
  }
  return {
    text: 'common.messages.password_update_validation_digits',
    status,
    dataTest: 'password-digit-validation',
  }
}

const usePasswordValidation = (password: Ref<string>): PasswordValidationUseCase => {

  const validators = computed((): PasswordValidationModel[] => {
    return [
      lengthValidation(password.value),
      lowercaseValidation(password.value),
      uppercaseValidation(password.value),
      digitValidation(password.value),
    ]
  })

  return {
    validators,
  }

}

export default usePasswordValidation
